export const AccountModalSuperscriptIcon = ({ className = "" }) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <rect width="44" height="44" rx="22" fill="#00A3FF" />
      <path
        d="M29.8237 16.8196C29.8237 14.9189 28.0563 13.9333 25.3843 13.9333C21.7013 13.9333 19.208 16.4676 19.208 19.2835C19.208 20.6914 19.6793 21.7474 20.3292 23.1887C21.0514 24.9152 21.7735 25.7822 21.7735 27.3087C21.7735 28.9278 20.7625 29.7355 18.8127 29.7355C17.3303 29.7355 16.3915 29.139 16.3915 28.5388C16.3573 28.0127 16.9351 27.6941 16.9351 26.9197C16.95 26.7356 16.9238 26.5506 16.8581 26.3774C16.7925 26.2042 16.689 26.047 16.5549 25.9166C16.4208 25.7863 16.2593 25.6859 16.0814 25.6223C15.9036 25.5588 15.7137 25.5337 15.5249 25.5488C15.3077 25.5505 15.093 25.5951 14.894 25.6801C14.695 25.7651 14.5158 25.8886 14.3672 26.0431C14.2187 26.1976 14.1039 26.38 14.0298 26.5791C13.9557 26.7781 13.9238 26.9898 13.9362 27.2013C13.9742 29.1724 15.9582 30.7582 18.8469 30.7582C23.2178 30.7582 25.4565 28.3276 25.4565 25.9415C25.4185 24.252 24.8788 23.348 24.0844 21.2954C23.5067 19.7466 22.7123 18.3053 22.7123 17.179C22.7123 15.9452 23.6131 14.9559 25.3463 14.9559C26.9009 14.9559 27.2467 15.4154 27.2467 15.8711C27.2467 16.3268 26.8857 16.6825 26.8857 17.3531C26.8857 18.0941 27.4634 18.5499 28.33 18.5499C29.1966 18.5499 29.8237 17.8237 29.8237 16.8196Z"
        fill="white"
      />
    </svg>
  );
};
